import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Edit } from '@material-ui/icons/';
import { Button } from '@material-ui/core';
import UrlLink from '../../clientModule/components/Common/Table/UrlLink';
import { RootState } from '../../../redux/root';
import { InputTextWithLabel } from '../../../molecules';
import { dispatch } from '../../../redux/store';
import { setPermittingPristine, setSelectedJurisdiction } from '../../../redux/slices/wikiSlice';
import { urlRegex } from '../../../regex';
import { Buttons } from '../Inspections/ContactDataPopup';
import { useUpdatePermittingMutation } from '../../../redux/rtkQuery/apiWikiPermittingSlice';
import { objectKeysToSnakeCase } from '../../../utils';

const PermittingLinkToPortal = ({ show, setShow, resetSuccess }) => {
  const selectedJurisdiction = useSelector((s: RootState) => s.wikiSlice.selectedJurisdiction);
  const [updatePermitting] = useUpdatePermittingMutation();
  const [errors, setErrors] = useState<any>({});

  const setUrl = portalLink => {
    const _selectedJuri = {
      ...selectedJurisdiction,
      permitting: {
        ...selectedJurisdiction.permitting,
        portalLink,
      },
    };

    dispatch(setSelectedJurisdiction(_selectedJuri));
  };
  const setDescription = desc => {
    const _selectedJuri = {
      ...selectedJurisdiction,
      permitting: {
        ...selectedJurisdiction.permitting,
        portalLinkDescription: desc,
      },
    };

    dispatch(setSelectedJurisdiction(_selectedJuri));
  };
  //
  const onSave = async () => {
    dispatch(setPermittingPristine(false));
    const _errors = {};
    let errorsFound = false;
    if (!selectedJurisdiction.permitting.portalLinkDescription) {
      _errors.portalLinkDescription = { message: 'Portal Link Description is required!' };
      errorsFound = true;
    }
    if (!urlRegex.test(selectedJurisdiction.permitting.portalLink)) {
      _errors.portalLink = { message: 'Url must start with http:// or https://' };
      errorsFound = true;
    }

    if (errorsFound) {
      setErrors(_errors);
      return;
    }

    setShow(false);
    if (selectedJurisdiction.permitting.id !== -1) {
        const _res = await updatePermitting(objectKeysToSnakeCase(selectedJurisdiction.permitting));
        resetSuccess();
    }
  };
  return (
    <>
      {selectedJurisdiction?.permitting?.portalLink && selectedJurisdiction?.permitting?.portalLinkDescription && !show ? (
        <UrlLink caption={selectedJurisdiction?.permitting?.portalLinkDescription} value={selectedJurisdiction?.permitting?.portalLink} />
      ) : (
        <EmptyState>Not set</EmptyState>
      )}
      <IconWrapper>
        <Edit onClick={e => setShow(true)} />
        {show && (
          <LinkPopup>
            <InputTextWithLabel
              error={errors.portalLinkDescription}
              name="portalLinkDescription"
              label="Link Description"
              value={selectedJurisdiction?.permitting?.portalLinkDescription}
              onChange={e => setDescription(e.target.value)}
            />
            <InputTextWithLabel
              name="portalLink"
              label="Link"
              error={errors.portalLink}
              value={selectedJurisdiction?.permitting?.portalLink}
              onChange={e => setUrl(e.target.value)}
            />
            <Buttons>
              <Button variant="contained" color="primary" onClick={e => setShow(false)}>
                Cancel
              </Button>
              <Button variant="contained" color="primary" onClick={onSave}>
                Save
              </Button>
            </Buttons>
          </LinkPopup>
        )}
      </IconWrapper>
    </>
  );
};

export default PermittingLinkToPortal;

const Error = styled.div`
  color: red;
`;

const EmptyState = styled.div`
  font-size: 0.875rem;
  color: var(--neutral-400);
  font-style: italic;
`;

const IconWrapper = styled.div`
  cursor: pointer;
  position: relative;
  display: inline-flex;
  align-items: center;
  svg {
    font-size: 1.125rem;
    color: var(--neutral-500);
    transition: color 0.15s ease;
  }
  svg:hover {
    color: var(--primary-600);
  }
`;

const LinkPopup = styled.div`
  width: 363px;
  z-index: 3;
  background-color: #fff;
  box-shadow: 6px 6px var(--disabledButton);
  border: 3px solid var(--border);
  border-radius: 6px;
  position: absolute;
  left: -365px;
  top: 21px;
  padding: 9px;
`;
